import log from 'salvo-lite/log'

class ForceLinksToNewTab {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        let links = this._elem.querySelectorAll('a')
        links.forEach(link => {
            link.setAttribute('target', '_blank')
        })
    }
}

export default ForceLinksToNewTab



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ForceLinksToNewTab.js